/** At or above this many days, cadence copy uses whole weeks instead of days. */
export const BUY_AGAIN_CADENCE_WEEK_THRESHOLD_DAYS = 35;

export type BuyAgainCadenceUnit = "days" | "weeks";

/** Rounded interval for display under buy-again cards. */
export function buyAgainCadenceDisplay(avgIntervalDays: number): {
  count: number;
  unit: BuyAgainCadenceUnit;
} {
  if (avgIntervalDays >= BUY_AGAIN_CADENCE_WEEK_THRESHOLD_DAYS) {
    return { count: Math.round(avgIntervalDays / 7), unit: "weeks" };
  }
  return { count: Math.round(avgIntervalDays), unit: "days" };
}
